import PropTypes from 'prop-types';
import TrainerListing from '@/domain/Trainer/TrainerListing';
import TrainerListingLayout from '@/domain/Trainer/TrainerListingLayout';
import client from '@/api/client';
import { trainerListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: trainerListingQuery });

  return {
    props: {
      trainers: data?.trainers?.nodes || [],
    },
  };
}

const defaultProps = {
  trainers: [],
};

const propTypes = {
  trainers: PropTypes.arrayOf(PropTypes.object),
};

export default function Trainers({ trainers }) {
  return (
    <TrainerListingLayout>
      {trainers.map(({ id, title, ...trainer }) => (
        <div key={id}>
          <TrainerListing name={title} {...trainer} />
        </div>
      ))}
    </TrainerListingLayout>
  );
}

Trainers.defaultProps = defaultProps;
Trainers.propTypes = propTypes;
